import {useStoreon} from 'storeon/react';

export function useSiteConfigurations() {
  const { page } = useStoreon('page');

  return page.data.page.global.site_configuration;
}